<template>
  <div class="contact-us-page">
    <div>
      <div class="main_top">
        <!-- <video
          controls="controls"
          id="vedio"
          class="video"
          :src="this.videoSrc"
        ></video> -->
        <img :src="this.info.pic" alt="" id="vedio" class="video" />
      </div>
      <p class="bp_qdq">{{ this.info.name }}</p>
      <div class="bp_js">{{ this.info.subname }}</div>
      <div class="pic_img">
        <div class="title-top">
          <img src="@assets/images/pictureShow.png" alt="" />
          <span>活动案例展示</span>
        </div>
        <div
          class="imgList"
          v-for="item in img"
          :key="item"
          @click="toCaseDetail(item.id)"
        >
          <div class="same fl">
            <img :src="item.ico" alt="" />
            <p class="example">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getCaseData } from "@api/common";
import { exampleDetail } from "@api/common";
import { example } from "@api/common";
import { baseInfo } from "@utils/config.js";

export default {
  data() {
    return {
      aid: "",
      info: {},
      img: [],
      videoSrc: ""
    };
  },
  created() {
    const id = this.$route.query.aid;
    this.aid = id;
    this.getDataInfo();
    // console.log(this.videoSrc);
  },
  methods: {
    getDataInfo() {
      example({ type: 2, list: this.aid }).then(res => {
        // console.log(res);
        // console.log(res.data.link);
        this.info = res.data.front;
        this.img = res.data.data;
        // this.videoSrc = res.data.link;
        // console.log(this.img);
      });
      exampleDetail({ list: 1 }).then(res => {
        // console.log("信息1", res);
        this.info = res.data;
      });
    },
    toCaseDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/caseDetail",
        query: {
          id: id
        }
      });
    }
  },
  computed: {
    getWebSoketDomain() {
      return baseInfo.webSoketDomain;
    }
  }
};
</script>
<style lang="scss" scoped>
.contact-us-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    width: 93.3%;
    height: 28.3%;
    margin: 0.2rem auto;
    img {
      width: 100%;
      height: 4rem;
      border-radius: 0.1rem;
    }
  }
  .bp_qdq {
    padding-left: 0.23rem;
    font-family: SourceHanSansCN-Medium;
    font-size: 0.35rem;
    color: #202020;
    font-weight: 700;
  }
  .bp_js {
    margin-top: 0.1rem;
    padding-left: 0.23rem;
    font-family: SourceHanSansCN-Normal;
    font-size: 0.28rem;
    color: #666666;
    line-height: 0.4rem;
  }
  .title-top {
    margin-top: 0.2rem;
    margin-left: 0.3rem;
    img {
      width: 3.7%;
      height: 1.7%;
      vertical-align: baseline;
    }
    span {
      color: #3bbb61;
      font-size: 0.23rem;
      margin-left: 0.1rem;
    }
  }
  .pic_img {
    padding-left: 0.2rem;
  }
  .same {
    width: 45%;
    height: 2.3rem;
    margin-top: 0.25rem;
    margin-left: 0.1rem;
    margin-right: 0.2rem;
    margin-bottom: 0.1rem;
    position: relative;
    img {
      width: 100%;
      height: 90%;
    }
    .example {
      display: block;
      text-align: center;
      color: #202020;
      height: 0.4rem;
      line-height: 0.4rem;
      width: 100%;
      overflow: hidden;
    }
  }
  .fl {
    float: left;
  }
}
</style>
